"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestWorkspaceAreaMoveMulti = void 0;
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const AREA_MOVE_WORKSPACE_MULTI_MUTATION = (0, graphql_tag_1.default) `
  mutation AreaMoveWorkspaceMulti(
    $organizationId: ID!
    $assignments: [AreaWorkspaceAssignInput!]!
  ) {
    areaMoveWorkspaceMulti(
      organization: $organizationId
      assignments: $assignments
    ) {
      id
    }
  }
`;
const requestWorkspaceAreaMoveMulti = async (variables) => {
    const { data, errors } = await (0, apollo_1.mutate)(AREA_MOVE_WORKSPACE_MULTI_MUTATION, {
        variables,
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.areaMoveWorkspaceMulti;
};
exports.requestWorkspaceAreaMoveMulti = requestWorkspaceAreaMoveMulti;
